module.exports = __webpack_public_path__ + "img/growcify-payment-gateway-banner.deda06da.png";